/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Sign_OutInputs */

const en_us2_profile_sign_out = /** @type {(inputs: Profile_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign out`)
};

const pt_br2_profile_sign_out = /** @type {(inputs: Profile_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sair`)
};

const es_419_profile_sign_out = /** @type {(inputs: Profile_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar sesión`)
};

const pt_pt2_profile_sign_out = /** @type {(inputs: Profile_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminar sessão`)
};

const fr_fr2_profile_sign_out = /** @type {(inputs: Profile_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se déconnecter`)
};

const de_de2_profile_sign_out = /** @type {(inputs: Profile_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abmelden`)
};

const it_it2_profile_sign_out = /** @type {(inputs: Profile_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esci`)
};

/**
* | output |
* | --- |
* | "Sign out" |
*
* @param {Profile_Sign_OutInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_sign_out = /** @type {((inputs?: Profile_Sign_OutInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Sign_OutInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_sign_out(inputs)
	if (locale === "es-419") return es_419_profile_sign_out(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_sign_out(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_sign_out(inputs)
	if (locale === "de-DE") return de_de2_profile_sign_out(inputs)
	if (locale === "it-IT") return it_it2_profile_sign_out(inputs)
	return en_us2_profile_sign_out(inputs)
});
export { profile_sign_out as "profile.sign_out" }